/**
 * Authentication utility functions
 */

/**
 * Saves authentication data to localStorage
 * @param {string} token - JWT token
 * @param {Object} user - User data
 */
export const saveAuthData = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

/**
 * Clears authentication data from localStorage
 */
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

/**
 * Checks if user is authenticated
 * @returns {boolean} - True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

/**
 * Gets the current user data
 * @returns {Object|null} - User data or null if not authenticated
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

/**
 * Gets the authentication token
 * @returns {string|null} - JWT token or null if not authenticated
 */
export const getToken = () => {
  return localStorage.getItem('token');
};